<template>  
    <div class="input-area">
        <div class="rating-container">
            Оценка работы специалиста
            <span class="star-container">
                <md-button :disabled="disabled" class="md-icon-button" v-for="item in checkedStars" v-bind:key="item" @click="setRating(item)"><md-icon>star</md-icon></md-button>
                <md-button :disabled="disabled" class="md-icon-button" v-for="item in uncheckedStars" v-bind:key="item" @click="setRating(item)"><md-icon>star_border</md-icon></md-button>
            </span>
        </div>
        <md-field>
            <label>Комментарий</label>
            <md-textarea :disabled="disabled" v-model="rating.text">
            </md-textarea>
        </md-field>
    </div>
    
</template>
<script>
export default {
    name: "RatingControl",
    model: {
        prop: 'rating',
        event: 'rchanged'
    },
    props: {
        disabled: Boolean,
        rating: Object
    },
    data: () => ({
        ratingItems: [1, 2, 3, 4, 5],
    }),
    computed: {
        checkedStars: {
            get() {
                return this.ratingItems.slice(0, this.rating.value);
            }
        },
        uncheckedStars: {
            get() {
                return this.ratingItems.slice(this.rating.value);
            }
        }
    },
    methods: {
        setRating(value) {
            this.rating.value = value;
        }
    }
}
</script>
<style scoped lang="scss">
    .input-area {
        margin: 10px;
    }
    .star-container {
        font-size: 0px;
        .md-icon {
            cursor: pointer;
            color: gold !important;
        }
    }
    .rating-container {
        display: flex;
        flex-direction: column;
    }
</style>



// WEBPACK FOOTER //
// Components/supportNew/ratingControl.vue